<div *ngIf="!isSoloMode" class="product">
  <div class="product__image">
    <div [ngStyle]="{ 'background-image': 'url(' + thumborBaseUrl + '/600x0/' + option.imageUrl + ')' }"></div>
  </div>

  <div class="product__info">
    <header class="mt-2 mt-md-0">
      <h2 class="font-weight-bold m-0 product__title">{{ option.name }}</h2>
    </header>

    <div class="mt-3 text-nowrap d-flex align-items-baseline product__price">
      <span class="mr-1">
        <ng-container i18n="minimum price|The price tag on the item">From</ng-container>
      </span>

      <app-price [price]="getLowestPrice()" [currencyCode]="product.currency"></app-price>
    </div>

    <div class="py-2" [innerHTML]="option.description"></div>

    <button
      *ngIf="!isHotel; else hotel"
      (click)="expandBookingFlow()"
      class="btn btn-text product__expand"
      test-id="book-now-button"
    >
      <i
        class="fas"
        [ngClass]="{ 'fa-caret-down': !wineryBookingUiExpanded, 'fa-caret-up': wineryBookingUiExpanded }"
      ></i>
      <ng-container *ngIf="!isEvent" i18n="The “Book now” button caption">Book now</ng-container>
      <ng-container *ngIf="isEvent" i18n="The “Buy ticket” button caption">Buy ticket</ng-container>
    </button>
  </div>

  <div #bookingFlow>
    <app-add-option
      *ngIf="!isHotel && wineryBookingUiExpanded"
      [expanded]="wineryBookingUiExpanded"
      [option]="option"
      [languages]="languages"
    ></app-add-option>
  </div>
</div>

<ng-template #hotel>
  <div class="d-flex flex-column flex-lg-row">
    <div class="mt-3 mr-lg-2 mt-lg-0">
      <app-date-range-picker
        [getAvailabilityForPeriod]="getAvailabilityForPeriod"
        (change)="onDatepickerChange($event)"
      ></app-date-range-picker>
    </div>

    <ng-container *ngIf="hotelBookingPeriod">
      <div class="mt-3 mt-lg-0">
        <div
          style="min-width: 224px"
          class="d-flex justify-content-between options"
          [ngbPopover]="popContent"
          popoverClass="custom-popover"
          placement="auto"
          [autoClose]="'outside'"
          triggers="manual"
          #p="ngbPopover"
          (click)="p.open()"
        >
          <div class="item">
            <span class="label">
              <ng-container i18n="The “Guests” caption">Guests</ng-container>
            </span>

            <span style="line-height: 24px">
              {{ getTotalGuestsCount() }}
            </span>
          </div>

          <div *ngIf="getExtraBeds?.count > 0" class="item">
            <span class="label">
              <ng-container i18n="The “Extra beds” caption">Extra beds</ng-container>
            </span>

            <span style="line-height: 24px">
              {{ getExtraBeds?.count }}
            </span>
          </div>

          <div class="item">
            <span class="label">
              <ng-container i18n="The “Rooms” caption">Rooms</ng-container>
            </span>

            <span style="line-height: 24px">
              {{ selectedRoomQuantity }}
            </span>
          </div>
        </div>

        <ng-template class="p-4" #popContent>
          <div class="details-popover">
            <div *ngFor="let scheme of availablePricingSchemas" class="d-flex flex-column w-100">
              <div class="popover-item">
                <div>
                  <span class="title-text">
                    <ng-container
                      *ngIf="scheme.pricingSchemaId === pricingSchemas.Child"
                      i18n="The plural of “Child” pricing scheme"
                      >Children</ng-container
                    >

                    <ng-container
                      *ngIf="scheme.pricingSchemaId === pricingSchemas.Adult"
                      i18n="The plural of “Adult” pricing scheme"
                      >Adults</ng-container
                    >

                    <ng-container
                      *ngIf="scheme.pricingSchemaId === pricingSchemas.Student"
                      i18n="The plural of “Student” pricing scheme"
                      >Students</ng-container
                    >

                    <ng-container
                      *ngIf="scheme.pricingSchemaId === pricingSchemas.Senior"
                      i18n="The plural of “Senior” pricing scheme"
                      >Seniors</ng-container
                    >

                    <ng-container
                      *ngIf="scheme.pricingSchemaId === pricingSchemas.ExtraBed"
                      i18n="The “Extra beds” caption"
                      >Extra beds</ng-container
                    >
                  </span>
                  <div *ngIf="scheme.description" class="scheme-description">
                    <ng-container i18n="The “Ages” caption">Ages</ng-container>
                    {{ ' ' + scheme.description }}
                  </div>
                </div>

                <div class="number-box">
                  <button
                    [disabled]="isDecreaseCountDisabled(scheme)"
                    [ngClass]="{ disabled: isDecreaseCountDisabled(scheme) }"
                    (click)="decreaseCount(scheme)"
                  >
                    –
                  </button>

                  <div class="d-inline-block">
                    <span class="people-number noselect">{{ scheme?.count }}</span>
                  </div>

                  <button
                    [disabled]="isIncreaseCountDisabled(scheme)"
                    [ngClass]="{ disabled: isIncreaseCountDisabled(scheme) }"
                    (click)="increaseCount(scheme)"
                  >
                    +
                  </button>
                </div>
              </div>

              <hr class="m-0" />
            </div>

            <div class="popover-item">
              <div class="title-text">
                <span i18n="Number of rooms in the hotel">Rooms</span>
              </div>

              <div class="number-box">
                <button
                  [disabled]="isDecreaseRoomsCountDisabled()"
                  [ngClass]="{ disabled: isDecreaseRoomsCountDisabled() }"
                  (click)="decreaseRoomsCount()"
                >
                  –
                </button>

                <div class="d-inline-block">
                  <span class="people-number noselect">{{ selectedRoomQuantity }}</span>
                </div>

                <button
                  [disabled]="isIncreaseRoomsCountDisabled()"
                  [ngClass]="{ disabled: isIncreaseRoomsCountDisabled() }"
                  (click)="increaseRoomsCount()"
                >
                  +
                </button>
              </div>
            </div>
          </div>
        </ng-template>
      </div>

      <div class="d-flex flex-column ml-lg-auto mt-3 mt-lg-0">
        <div class="summary">
          <h2 class="header">
            <ng-container i18n="The summary caption">Summary</ng-container>
          </h2>

          <div style="padding: 8px 16px 0">
            <div *ngFor="let room of priceCalculations.roomsSummary; let i = index">
              <div class="item">
                <span>
                  {{ i + 1 }}
                  <ng-container i18n="Label for a single rooms; for example: “1 room”">room</ng-container>

                  {{ '(' + room.adults }}
                  <ng-container *ngIf="room.adults === 1" i18n="The singular of “Adult” pricing scheme|From summary"
                    >Adult</ng-container
                  >
                  <ng-container *ngIf="room.adults > 1" i18n="The plural of “Adult” pricing scheme|From summary"
                    >Adults</ng-container
                  >

                  <ng-container *ngIf="room.children > 0">
                    <ng-container>, </ng-container>

                    {{ room.children }}
                    <ng-container *ngIf="room.children === 1" i18n="The singular of “Child” pricing scheme|From summary"
                      >Child</ng-container
                    >
                    <ng-container *ngIf="room.children > 1" i18n="The plural of “Child” pricing scheme|From summary"
                      >Children</ng-container
                    >
                  </ng-container>

                  <ng-container>)</ng-container>
                </span>
                <span>{{ room.roomTotal | appCurrency: product.currency }}</span>
              </div>
            </div>

            <div *ngIf="getExtraBeds?.count > 0" class="item">
              <span>
                <ng-container i18n="The “Extra beds” caption">Extra beds</ng-container>
                {{ ' x ' + getExtraBeds?.count }}
              </span>

              <span>{{ getExtraBeds.rate * getExtraBeds?.count | appCurrency: product.currency }}</span>
            </div>

            <div class="item mt-3 fs-14 fw-500">
              <span>Subtotal</span>
              <span>
                {{ getSubtotal() | appCurrency: product.currency }}
              </span>
            </div>
          </div>

          <div class="total">
            <div class="d-flex flex-column">
              <span
                class="fw-700"
                i18n="Cart grand total caption|Displayed below the item table, before the grand total price e.g. €205"
                >Total</span
              >

              {{ selectedRoomQuantity }}
              <ng-container *ngIf="selectedRoomQuantity === 1" i18n="Label for a single rooms; for example: “1 room”"
                >room</ng-container
              >

              <ng-container *ngIf="selectedRoomQuantity > 1" i18n="Label for multiple rooms; for example: “3 rooms”"
                >rooms</ng-container
              >
              x
              {{ priceCalculations.numberOfNights }}

              <ng-container
                *ngIf="priceCalculations.numberOfNights === 1"
                i18n="Label for single night; for example: “1 night”"
                >night</ng-container
              >

              <ng-container
                *ngIf="priceCalculations.numberOfNights > 1"
                i18n="Label for multiple nights; for example: “3 nights”"
                >nights</ng-container
              >
            </div>

            <span style="align-self: end">
              {{ priceCalculations.total | appCurrency: product.currency }}
            </span>
          </div>
        </div>

        <div class="mt-3">
          <button
            (click)="addToCart()"
            [disabled]="!isAddButtonEnabled()"
            class="btn btn-text product__add-to-cart"
            test-id="add-to-cart-button"
          >
            <ng-container i18n="Button label">Add to cart</ng-container>
          </button>
        </div>
      </div>
    </ng-container>
  </div>
</ng-template>

<div *ngIf="isSoloMode" class="solo-mode pt-2">
  <h2 class="font-weight-bold mb-1 product__title">{{ option.name }}</h2>

  <app-add-option
    *ngIf="!isHotel; else hotel"
    [expanded]="true"
    [option]="option"
    [languages]="languages"
  ></app-add-option>
</div>
